import About from "../../components/AboutSection/About/About";
import Catalog from "../../components/CatalogSection/Catalog";
import Feedback from "../../components/FeedbackSection/Feedback";
import Hero from "../../components/Hero/Hero";
import { Wrapper } from "./MainPage.styled";

const MainPage = () => {

    return (
        <Wrapper>
            <Hero />
            <About />
            <Catalog />
            <Feedback />
        </Wrapper>
    )
};

export default MainPage;